// import { RestResponseStatus } from 'scbk-services/http/constants';
import _ from 'scbk-services/utils/lodash-extension.ts';

import { AxiosError, HttpStatusCode } from 'axios';
import { i18n } from 'scbk-services/i18n';
import { RestResponseError } from 'scbk-services/types/error/error';
import type { CommonRestResponse } from 'scbk-services/types/http/axios-extension';
import { RestResponse } from 'scbk-services/types/http/rest-response';

/**
 * 응답 status code
 * @param error
 * @returns
 */
const createErrorDetailsFromHttpStatus = (
    error: AxiosError,
): RestResponse.ErrorDetails | null | undefined => {
    const status = error.status;
    if (!status) {
        return null;
    }

    const locale = i18n.resolvedLanguage ?? i18n.language;
    let errMsg =
        locale == 'ko'
            ? '서버접속이 원활하지 않습니다.<br/> 잠시 후 다시 접속해주세요.'
            : 'Unable to connect to the server.<br />Try again.';
    if (status === 0) {
        errMsg =
            locale === 'ko'
                ? '통신중 오류가 발생했습니다.<br />다시 시도해 주세요.'
                : 'An error occurred.<br />Try again.';
    }

    return {
        code: `HTTP_ERROR_${status}`,
        //title: 'HTTP ERROR',
        errorMessage: errMsg,
    };
};

/**
 * 전달된 Error객체를 이용하여 오류데이터를 생성하여 리턴한다.
 */
const createErrorDetailsFromError = (
    error: unknown,
): RestResponse.ErrorDetails | null | undefined => {
    if (!(error instanceof Error)) {
        return null;
    }

    if (error instanceof AxiosError) {
        return createErrorDetailsFromHttpStatus(error);
    }

    const err = error as Error;
    return {
        code: 'RUNTIME_ERROR',
        title: '',
        errorMessage: `예기치않은 오류가 발생했습니다. <br />${err.message}`,
    };
};

/**
 *
 * @param response
 */
const checkRestResponse = <Data>(response: CommonRestResponse<Data>): void => {
    if (_.isNotInRange(response.status, 200, 300)) {
        throw new RestResponseError('HTTP_ERROR', 'HTTP_ERROR', 'HTTP status code error');
    }

    // if (_.isEqual(response.data.status, RestResponseStatus.FAILURE)) {
    //      throw response;
    // }

    if (_.isNotEmpty(response.data.error)) {
        throw response;
    }
};

/**
 *
 * @param error
 */
const checkAxiosErrorResponse = (error: AxiosError): void => {
    const status = error.status ?? HttpStatusCode.Ok;
    if (_.isNotInRange(status, 200, 300)) {
        throw new RestResponseError('HTTP_ERROR', 'HTTP_ERROR', 'HTTP status code error');
    }
};

export {
    checkAxiosErrorResponse,
    checkRestResponse,
    createErrorDetailsFromError,
    createErrorDetailsFromHttpStatus,
};
